"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageItems = exports.pageRange = void 0;
var pageRange = function (from, to) {
    var range = [];
    from = from > 0 ? from : 1;
    for (var i = from; i <= to; i++) {
        range.push(i);
    }
    return range;
};
exports.pageRange = pageRange;
/**
 * Generate entries for pagination buttons.
 * Code is adapted from Vuetify packages/vuetify/src/components/VPagination/VPagination.ts
 * -1 indicates dots or '...' entry.
 *
 * @param value
 * @param length
 * @param totalVisible Limit the number of the shown pagination buttons
 * @param maxButtons An alias for totalVisible
 */
var pageItems = function (value, length, totalVisible, maxButtons) {
    if (totalVisible === void 0) { totalVisible = 9; }
    if (maxButtons === void 0) { maxButtons = 0; }
    var maxLength = Math.min(Math.max(0, totalVisible) || length, Math.max(0, maxButtons) || length, length);
    if (length <= maxLength) {
        return pageRange(1, length);
    }
    var even = maxLength % 2 === 0 ? 1 : 0;
    var left = Math.floor(maxLength / 2);
    var right = length - left + 1 + even;
    if (value > left && value < right) {
        var start = value - left + 2;
        var end = value + left - 2 - even;
        return __spreadArray(__spreadArray([1, -1], __read(pageRange(start, end))), [-1, length]);
    }
    else if (value === left) {
        var end = value + left - 1 - even;
        return __spreadArray(__spreadArray([], __read(pageRange(1, end))), [-1, length]);
    }
    else if (value === right) {
        var start = value - left + 1;
        return __spreadArray([1, -1], __read(pageRange(start, length)));
    }
    else {
        return __spreadArray(__spreadArray(__spreadArray([], __read(pageRange(1, left))), [-1]), __read(pageRange(right, length)));
    }
};
exports.pageItems = pageItems;
//# sourceMappingURL=PaginationUtil.js.map